export default "__VITE_ASSET__7343b3b1__"